import LogoutPage from './LogoutPage'

export default LogoutPage
// eslint-disable-next-line import/export
export * from './LogoutPage'
